import { render, staticRenderFns } from "./ItemsHeader.vue?vue&type=template&id=0c42d91c&scoped=true&"
import script from "./ItemsHeader.vue?vue&type=script&lang=js&"
export * from "./ItemsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ItemsHeader.vue?vue&type=style&index=0&id=0c42d91c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c42d91c",
  null
  
)

export default component.exports